module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-permanents2.880a620f.png";